const validateAttendeeVisibilityForm = ({ shareValue }) => {
  return {
    shareValue: !['public', 'private'].includes(shareValue)
  };
};

export default validateAttendeeVisibilityForm;
